import(/* webpackMode: "eager" */ "/vercel/path0/app/(frontend)/(konfigurator)/error.tsx");
